import { getTruckTypes } from '@utils';

export const getTruckType = (id: number) => {
	const truckType = getTruckTypes.find((t) => t.value === id);
	return truckType ? truckType.alias : 'ANY';
}
